<script>
    import { Navigate } from 'svelte-router-spa';
    import { onMount } from 'svelte';
    export let currentRoute;

    onMount(() => {
        currentRoute = currentRoute;
    })
    $: document.querySelectorAll(`a[href="${currentRoute.name}"]`).forEach(a => a.classList.add('font-bold'));
    $: document.querySelectorAll(`a:not(a[href="${currentRoute.name}"])`).forEach(a => a.classList.remove('font-bold'));
</script>

<div class="w-full p-1 bg-brand"></div>
<header class="flex flex-row items-center justify-center w-full p-3 px-4 shadow-lg z-[100] bg-white transition-all duration-500 ease-in-out">

    <div class="flex flex-row items-center justify-around flex-1">        
        <Navigate to="/shops">Shops</Navigate>
        <Navigate to="/places">Places</Navigate>
        <Navigate to="/account">Account</Navigate>
        <Navigate to="/navigator">Navigator</Navigate>
    </div>

    <Navigate to="/" styles="flex flex-row items-center justify-around px-4">- <img src="/favicon.png" alt="Logo" class="h-[2.5rem] rounded-lg aspect-square mx-4"> -</Navigate>

    <div class="flex flex-row items-center justify-around flex-1">
        <Navigate to="/feedback">Feedback</Navigate>
        <a href="http://phoenixcraft.serv.nu:10445/">Dynmap</a>
        <a href="https://phoenixcraft-maps.macnugget.org/">Mac's Maps</a>
        <a href="https://server.pro/server/11297913/">Server Donations</a>
    </div>

</header>

<style>
    header:global div a {
        @apply flex-1 text-center;
	    position: relative;
	}
    
    header:global div a:before {
		content: "";
		position: absolute;
		width: 100%;
		height: 2px;
		bottom: 0;
		margin: -5px 0;
		background-color: #000000;
		visibility: hidden;
		transform: scaleX(0);
		transition: all 0.4s ease-in-out 0s;
        left: 0;
	}
	header:global div a:hover:before {
		visibility: visible;
		transform: scaleX(1);
	}
</style>